import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { createContext, useContext } from "react";
const LinkStore = /*#__PURE__*/ createContext(null);
export const LinkProvider = (param)=>{
    let { children , value  } = param;
    const store = {
        Link: value
    };
    // return <></>
    return /*#__PURE__*/ _jsx(LinkStore.Provider, {
        value: store,
        children: children
    });
};
export const useLinkStore = ()=>{
    const store = useContext(LinkStore);
    if (!store) {
        // this is especially useful in TypeScript so you don't need to be checking for null all the time
        throw new Error("useStore must be used within a StoreProvider.");
    }
    return store;
};
